var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7585 1.76622C19.4208 0.436118 17.2 0.66222 16.0642 2.17931L14.4978 4.27208C13.5765 5.50348 13.6645 7.21259 14.7459 8.28771L15.0867 8.62658C15.0947 8.63876 15.1108 8.66685 15.1277 8.71154C15.1621 8.80275 15.2069 8.98793 15.1599 9.29162C15.0633 9.91422 14.5753 11.0593 12.7761 12.8483C10.9772 14.637 9.82481 15.1238 9.19605 15.2203C8.88915 15.2674 8.70133 15.2227 8.60816 15.1881C8.55972 15.1701 8.53045 15.1516 8.51929 15.1442L8.51734 15.1422L7.97046 14.5992C7.00831 13.6424 5.52265 13.4583 4.31812 14.1129L1.94409 15.4029C0.120787 16.3947 -0.319476 18.8576 1.15113 20.3199L2.9148 22.0738C3.42674 22.5829 4.09736 22.9884 4.8982 23.0631C7.05387 23.2641 12.1756 23.0204 17.5867 17.6402C22.6585 12.5971 23.6057 8.22921 23.7253 6.1256C23.7804 5.15473 23.3224 4.31581 22.7078 3.7047L20.7585 1.76622Z",
    fill: "url(#paint0_radial_2745_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2745_94",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9997 22.9031) rotate(-90) scale(21.7284 22.9444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22A277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#24AA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BC490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGradient);
export default __webpack_public_path__ + "static/media/phone-gradient.a1dce6ab356dfd5e50dbc19229b2d055.svg";
export { ForwardRef as ReactComponent };